// comps/WellMapPanel.jsx

import React, { memo } from 'react';

import "@arcgis/map-components/components/arcgis-map";
import "@arcgis/map-components/components/arcgis-search";
import "@arcgis/map-components/components/arcgis-basemap-gallery";
import "@arcgis/map-components/components/arcgis-legend";
import "@arcgis/map-components/components/arcgis-layer-list";
import "@arcgis/map-components/components/arcgis-expand";
import "@arcgis/map-components/components/arcgis-zoom";



import MapSelection from './MapSelection';

/**
 * WellMapPanel - Encapsulates the ArcGIS Map and its associated widgets.
 *
 * @param {Object} gallerySource - The source configuration for the Basemap Gallery.
 * @param {Function} onViewReady - Callback for when the ArcGIS MapView is ready.
 * @param {Function} onMapClick - Callback for clicking on the map.
 * @param {Function} onRectangleClick - Callback to activate the rectangle selection tool.
 */
const WellMapPanel = ({
  gallerySource,
  onViewReady,
  onMapClick,
  onRectangleClick
}) => {
  return (
    <arcgis-map
      basemap="osm"
      id="IdMapViewerReservationWithDetailsPanel"
      style={{ width: '100%', height: '100%' }}
      popup-disabled
      onarcgisViewReadyChange={onViewReady}
      onarcgisviewclick={onMapClick}
    >
      {/* Search & Navigation */}
      <arcgis-search slot="top-right" />
      <arcgis-zoom slot="top-right" />

      {/* Expandable Basemap Gallery */}
      <arcgis-expand slot="top-right">
        <arcgis-basemap-gallery source={gallerySource} />
      </arcgis-expand>

      {/* Layer Management */}
      <arcgis-expand slot="top-left">
        <arcgis-layer-list />
      </arcgis-expand>

      {/* Legend */}
      <arcgis-expand slot="bottom-right">
        <arcgis-legend />
      </arcgis-expand>

      {/* Custom Tools (Rectangle Selection) */}
      <arcgis-expand slot="bottom-left">
        <MapSelection onClick={onRectangleClick} />
      </arcgis-expand>
    </arcgis-map>
  );
};

// Use memo to prevent re-renders unless props change (important for GIS performance)
export default memo(WellMapPanel);